<template >
    <div class="wrapper" v-if="importObj">
        <!-- 导入 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="importObj.title" :visible.sync="showImport" width="500px" left :before-close="cancelImportDialog" v-loading="stuLoading" element-loading-text="正在导入，请稍候..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <div class="warning-wrapper">
                <span class="el-icon-warning warning"></span>
                <span v-html="warningMsg"></span>
            </div>
            <div class="import-dialog">
                <p class="red">{{importErrorMsg}}</p>
                <div>
                    <el-input readonly class="input-text" v-model="importFileName"></el-input>
                    <div class="rel-import-btn">
                        选择文件
                        <input accept=".xls,.xlsx" ref="importFile" class="import-btn" type="file" @change="changeExl" />
                    </div>

                </div>
                <div class="down-tepmlate">
                    <i></i>
                    <a :href="importObj.url" :download="importObj.title + '模板.xlsx'">{{importObj.text}}</a>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="uploadFile">确定</el-button>
                <el-button @click="cancelImportDialog">取消</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showImportSuccess" width="400px" left :title="importObj.title" :before-close="closeDialog">
            <div style="height:158px;padding:30px 50px;text-align: center">
                <div style="margin-bottom:20px;">
                    <span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span>
                </div>
                <p>导入成功
                    <span class="red">{{stotal}}</span>条;失败
                    <span class="red">{{etotal}}</span>条!</p>
                <div v-show="etotal > 0" class="down-tepmlate" style="padding-top:0;">
                    <i></i>
                    <a @click="downErrExl(importObj.errpath)">点击下载失败名单列表</a>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmDialog">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import api from "@/api";

export default {
    components: {},
    props: {
        /**  importObj示例
             * this.importObj= {
                *    title:'导入宿舍',--- 弹框标题
                *    text:'点击下载宿舍导入模板', ---'下载模板提示文字'
                *    url:'static/宿舍导入模板.xlsx', --- 下载模板链接
                *    api:api.systemConfig.importHostel, ----导入的接口函数
                *    key: 'hostelFile'  ----- 导入传给后台的文件key值
                };
            **/
        importObj: {
            type: Object,
            default: null
        },
        showImport: {
            type: Boolean,
            default: false
        },
        warningMsg: {
            type: String,
            default: '带<span class="red">*</span>号为必填项'
        }
    },
    data () {
        return {
            showImportSuccess: false,
            importErrorMsg: "",
            importFileName: "",
            fileName: "",
            etotal: "",
            stotal: "",
            lunxunrequesttimer: null,
            stuLoading: false
        };
    },
    watch: {},
    computed: {
        //   warningMsg() {
        //       return this.warningMSG
        //   }
    },
    methods: {
        closeDialog () {
            this.$emit("importFinishCallback");
            done();
        },
        comfirmDialog () {
            this.$emit("importFinishCallback");
            this.showImportSuccess = false;
        },
        changeExl (event) {
            if (event.target.value !== "") {
                var reg = new RegExp("(\.xls|\.xlsx)$");
                if (!reg.test(event.target.value)) {
                    this.$message('导入文件格式有误，请核查后再试！');
                    event.target.value = '';
                    //   this.importFileName
                    return;
                }
                var file = this.$refs.importFile.files;
                var formData = new FormData();
                formData.append(this.importObj.key, file[0]);
                this.importFileName = file[0].name;
                this.File = formData;
            }
        },
        uploadFile () {
            this.importErrorMsg = '';
            if (!this.File || this.importFileName === "") {
                this.$message("请先选择文件！");
                return;
            }
            this.importObj.api(this.File).then(res => {
                this.importFileName = "";
                this.File = null;
                this.$refs.importFile.value = "";

                if (res.code == 0) {
                    var key, value;
                    [key, value] = Object.entries(res.data)[0];
                    let lunxunrequest = () => {
                        return api.common.getImportStatus({ key: key, value: value }).then((res) => {
                            if (res.code == 0 && res.data !== null) {
                                if (res.data.code && res.data.code != 0) {
                                    this.importErrorMsg = res.data.message;
                                    this.stuLoading = false;
                                } else {
                                    clearTimeout(this.lunxunrequesttimer);
                                    this.stuLoading = false;
                                    if (this.$refs.importFile) {
                                        this.$refs.importFile.value = '';
                                    }
                                    this.importFileName = '';
                                    this.importErrorMsg = '';
                                    this.File = null;
                                    this.openImportSuccess(res.data.successCount, res.data.failCount, res.data.failFilePath);
                                }

                            } else {
                                this.lunxunrequesttimer = setTimeout(() => {
                                    lunxunrequest();
                                }, 2000)
                            }
                        })
                    }
                    this.stuLoading = true;
                    lunxunrequest();

                } else {
                    this.importErrorMsg = res.message;
                }
            });
        },
        downErrExl (path) {
            api.common.downloadFailFile(path).then(res => {
                this.downFile(res, "错误记录文件下载.xls");
            });
        },
        openImportSuccess (s, e, path) {
            this.$emit("update:showImport", false);
            this.showImportSuccess = true;
            this.stotal = s;
            this.etotal = e;
            this.importObj.errpath = path;
        },
        downFile (response, name) {
            if (!response) {
                return;
            }
            let url = window.URL.createObjectURL(new Blob([response]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        cancelImportDialog () {
            this.$emit("update:showImport", false);
            this.importErrorMsg = "";
            this.importFileName = "";
            this.File = null;
            this.$refs.importFile.value = "";
        }
    },
    created () { },
    mounted () { }
};
</script>
<style lang="scss" scoped>
.warning {
  color: #e6a23c;
}
.red {
  color: red;
}
.down-tepmlate {
    color: #26aef3;
    padding-top: 10px;
    i {
      display: inline-block;
      vertical-align: bottom;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background: url('../../../static/images/systemConfig/down.png') 0 0 no-repeat;
    }
    a {
      text-decoration: underline;
      color: #26aef3;
      font-size: 13px;
    }
  }
.import-dialog {
  padding: 0 20px 20px 20px;
  .input-text {
    width: 250px;
    margin-right: 10px;
  }
  .warning {
    color: #e6a23c;
    margin-right: 5px;
  }
  .rel-import-btn {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 140px;
    height: 30px;
    color: #fff;
    background-color: #e6a23c;
    border-radius: 4px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    .import-btn {
      position: absolute;
      left: 0;
      width: 140px;
      height: 30px;
      z-index: 2;
      opacity: 0;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/importUpload/importUpload.vue